import type { PathObjectInterface } from '@/map-phaser-new/interfaces'

export const clubBallonRightPath: PathObjectInterface = {
  mainPath: { x: 3155, y: 561 },
  spline: [3155, 561, 3155, 623, 3156, 694],
}
